module.exports = __webpack_public_path__ + "img/IMG027.c6781972.jpg";